var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dish-tags"},_vm._l((_vm.tags),function(tag,index){return _c('v-icon',{key:index,attrs:{"small":"","color":tag.color,"title":tag.title}},[_vm._v(_vm._s(tag.icon))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }